import angular from "angular";

angular
  .module("ticketco/common/time_slots")
  .factory("TimeSlotsPersistance", TimeSlotsPersistance);

function TimeSlotsPersistance($http, Locale) {
  var unwrapResponse = R.path(["data"]);

  function url(entityId, promocode) {
    return Locale.url(
      "/events/" + entityId + "/promo_codes/?promo_code=" + promocode
    );
  }

  function applyPromocode(eventId, promocode) {
    return $http.post(url(eventId, promocode)).then(unwrapResponse);
  }

  return {
    applyPromocode: applyPromocode,
  };
}
